import { createContext, PropsWithChildren, useContext, useState } from "react";

import { ICompany } from "@@types/ICompany";

interface CompanyContextData {
  currentCompany: ICompany | undefined;
  setCurrentCompany: React.Dispatch<React.SetStateAction<ICompany | undefined>>;
  isVisible: boolean;
  handleToggleVisibility: () => void;
}

export const CompanyContext = createContext({} as CompanyContextData);

export const useCompanyContext = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompanyContext must be used within a CompanyProvider");
  }
  return context;
};

export function CompanyProvider({ children }: PropsWithChildren) {
  const [currentCompany, setCurrentCompany] = useState<ICompany | undefined>(undefined);
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const handleToggleVisibility = () => {
    setIsVisible(state => !state);
  };

  return (
    <CompanyContext.Provider
      value={{
        currentCompany,
        setCurrentCompany,
        isVisible,
        handleToggleVisibility,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
}
